import type { IconSvgObject } from './types';

const SpeedTrain02Icon: IconSvgObject = [
  ["path", { d: "M2 3H9.33333C11.0643 3 12.7486 3.56142 14.1333 4.6L20 9C21.259 9.94427 22 11.4262 22 13C22 14.1046 21.1046 15 20 15H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2 19H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 19V21M12 19V21M6 19V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 11L9.94756 10.9998C10.6288 10.9998 11.2898 11.2316 11.8218 11.6572L16 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M10 7H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default SpeedTrain02Icon;
